/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function AddApplicationController($scope, $mdDialog, $state, $stateParams, $document, $q, types, applicationService,
                                                 networkSettingsService, apiLimitsService, entityTableConfiguration) {

    var vm = this;

    vm.$onInit = function () {
        vm.entityTableConfiguration = entityTableConfiguration;

        vm.entity = {
            networkSettings: networkSettingsService.createDefaultNetworkSettings(),
            apiLimits: apiLimitsService.createDefaultApiLimits()
        };

        vm.entityType = vm.entityTableConfiguration.entityType;
        vm.translations = types.entityTypeTranslations[vm.entityType];

        vm.add = add;
        vm.cancel = cancel;
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        switch (vm.entityTableConfiguration.scope) {
            case types.scope.subCustomer:
                if ($stateParams.subCustomerId) {
                    vm.entity.subCustomerId = {
                        entityType: types.entityType.subCustomer,
                        id: $stateParams.subCustomerId
                    };
                }
                break;
        }
        var newNetworkSettings = vm.entity.networkSettings;
        var newApiLimits = vm.entity.apiLimits;
        applicationService.saveApplication(vm.entity).then(
            (entity) => {
                vm.entity = entity;
                networkSettingsService.getNetworkSettings(entity.id.entityType, entity.id.id).then(
                    (networkSettings) => {
                        newNetworkSettings.entityId = networkSettings.entityId;
                        newNetworkSettings.id = networkSettings.id;
                        networkSettingsService.saveNetworkSettings(newNetworkSettings).then(
                            (networkSettings) => {
                                vm.entity.networkSettings = networkSettings;
                                apiLimitsService.getApiLimits(entity.id.entityType, entity.id.id).then(
                                    (apiLimits) => {
                                        newApiLimits.entityId = apiLimits.entityId;
                                        newApiLimits.id = apiLimits.id;
                                        apiLimitsService.saveApiLimits(newApiLimits).then(
                                            (apiLimits) => {
                                                vm.entity.apiLimits = apiLimits;
                                                $scope.theForm.$setPristine();
                                                $mdDialog.hide();
                                            }
                                        );
                                    }
                                );
                            }
                        );
                    }
                );
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/application/add-application.controller.js